// removed by extract-text-webpack-plugin
module.exports = {"profileHeader":"_2yXCwiOZtuKi8AiXDre2wD","bin":"Jumr0vt2xb6e9YfkWtWT1","shape":"E5vrOZusupl9M0NEH5T08","userInfo":"_2_XEINgVtuToZKG2juSgbK","avatar":"JZIXPNp_GsMCwOCEo0VAL","nametag":"v-wxb0kvooH7VU36U2tZo","name":"_11y-oQV2ZQB9KQLxrSSV4o","tag":"_25yGvv1zrK9mWCofShVHs4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/profileHeader.scss
// module id = 456
// module chunks = 0